import { render, staticRenderFns } from "./CurrentTime.vue?vue&type=template&id=486dd790&scoped=true&"
import script from "./CurrentTime.vue?vue&type=script&lang=js&"
export * from "./CurrentTime.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTime.vue?vue&type=style&index=0&id=486dd790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dd790",
  null
  
)

export default component.exports